import { module } from 'modujs';
import {gsap} from 'gsap';
import { MorphSVGPlugin } from "../vendors/gsap/MorphSVGPlugin";
import drawSvgPlugin from '../vendors/gsap/DrawSVGPlugin';
const { ScrollTrigger } = require("gsap/dist/ScrollTrigger");

export default class extends module {
  constructor(m)
  {
    super(m);


    this.textItems = this.el.querySelectorAll('p, h2, h3, ul')
    // this.titleItems = this.el.querySelectorAll('h3')

    this.tweenArray = []
    //console.log("✅TEXT APPEAR✅")
  }

  init(){

    //console.log(this.paragraphItems)
    this.textItems.forEach((el,index)=>{

      let tweens = gsap.fromTo(el, {opacity:0,y:30},{
        y:0,
        scrollTrigger: {
          trigger: el,
          // markers: true,
          start: "top 90%"
        },
        opacity: 1,
        ease: "power2.out",
        duration:1
      });
      this.tweenArray.push(tweens)

    })

    // this.titleItems.forEach((el,index)=>{
    //
    //   let tweens = gsap.fromTo(el, {opacity:0,y:30},{
    //     y:0,
    //     scrollTrigger: {
    //       trigger: el,
    //       // markers: true,
    //       start: "top 90%"
    //     },
    //     opacity: 1,
    //     ease: "power2.out",
    //     duration:1
    //   });
    //   this.tweenArray.push(tweens)
    //
    // })

  }


  destroy() {
    // destroy method
    this.tweenArray.forEach((el,index)=>{
      el.kill()
    })
    //console.log('DESTROYED tweens')
  }

}





// WEBPACK FOOTER //
// ./scripts/modules/textAppear.js